import { useQuery } from "@tanstack/react-query";
import { useHousehold } from "@/context/HouseholdContext";
import { api } from "@/lib/api";

export const useHouseholdDetail = () => {
  const { active } = useHousehold();
  const q = useQuery({ queryKey: ["household", active?.id], queryFn: () => api.get(`/households/${active.id}`).then((r) => r.data), enabled: !!active });
  const role = q.data?.my_role;
  return { ...q, canManage: ["owner", "admin"].includes(role), canEdit: ["owner", "admin", "adult"].includes(role) };
};
